import { AbstractField } from './AbstractField';

export type ListValueField<U> = { id: string; value: U }[];

export abstract class AbstractListField<V, U> extends AbstractField<V, U[], ListValueField<U>> {
    protected makeValueArray(values: ListValueField<U>): U[] {
        return Array.isArray(values) ? (values.map(value => (value.value ? { ...value.value } : value)) as any) : [];
    }
}
